export const msgConstant = {
    PLEASE_CORRECT_ERRORS_BELOW: 'Please correct error(s) below'
};
